var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.583 0.564941L9.85938 6.27989L11.2957 2.91189L17.583 0.564941Z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.435547 0.571777L6.70608 2.91242L8.06989 6.32459L0.435547 0.571777Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4746 12.719L17.8883 12.784L16.6953 16.8369L12.5298 15.69L14.4746 12.719Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52534 12.719L5.46296 15.69L1.30444 16.837L0.118652 12.784L3.52534 12.719Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8841 5.45532L8.02365 9.96119L3.84912 9.77126L5.03653 7.97988L5.05156 7.9626L7.8841 5.45532Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0725 5.40503L12.9483 7.96275L12.9632 7.97989L14.1506 9.77128L9.97705 9.96116L10.0725 5.40503Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58521 12.7321L7.86463 14.5081L5.2168 15.7865L5.58521 12.7321Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4149 12.7318L12.7757 15.7865L10.1353 14.508L12.4149 12.7318Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1938 14.3407L12.8732 15.6381L10.3809 16.8226L10.4067 16.0397L10.1938 14.3407Z",
    fill: "#D5BFB2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80562 14.3413L7.60107 16.027L7.61785 16.8217L5.11963 15.6381L7.80562 14.3413Z",
    fill: "#D5BFB2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03182 10.5492L7.73199 12.0207L5.34814 11.3224L7.03182 10.5492Z",
    fill: "#233447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9681 10.5494L12.6596 11.3224L10.2681 12.0206L10.9681 10.5494Z",
    fill: "#233447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76752 12.717L5.38217 15.8839L3.31689 12.7863L5.76752 12.717Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2329 12.717L14.6836 12.7863L12.6106 15.884L12.2329 12.717Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2109 9.59216L12.4274 11.4098L11.0524 10.7814L10.394 12.1655L9.9624 9.78546L14.2109 9.59216Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78809 9.59216L8.03737 9.78549L7.60577 12.1655L6.94728 10.7816L5.57945 11.4099L3.78809 9.59216Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 9.21924L5.68582 11.2668L5.75575 13.2882L3.66797 9.21924Z",
    fill: "#E27525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3342 9.21545L12.2427 13.2917L12.3214 11.2667L14.3342 9.21545Z",
    fill: "#E27525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93874 9.34387L8.01995 9.85504L8.22063 11.1285L8.09162 15.0396L7.48165 11.8977L7.48145 11.8653L7.93874 9.34387Z",
    fill: "#E27525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0599 9.33679L10.5184 11.8652L10.5182 11.8977L9.90672 15.0475L9.88252 14.2596L9.78711 11.1053L10.0599 9.33679Z",
    fill: "#E27525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 11.1853L12.4325 12.9416L10.3039 14.6L9.87354 14.296L10.3559 11.8115L12.5008 11.1853Z",
    fill: "#F5841F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50684 11.1854L7.64432 11.8116L8.12666 14.2961L7.69634 14.6001L5.56759 12.9415L5.50684 11.1854Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7124 15.2502L7.43575 16.5406L7.42422 15.9896L7.65208 15.7896H10.3474L10.5835 15.9889L10.5661 16.5396L13.2722 15.2535L11.9554 16.3416L10.3632 17.4353H7.63026L6.03902 16.3372L4.7124 15.2502Z",
    fill: "#C0AC9D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99881 14.1689L10.3839 14.4409L10.6095 16.2413L10.283 15.9655H7.71828L7.39795 16.2468L7.61619 14.4411L8.00137 14.1689H9.99881Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0727 0.723145L17.9998 3.50453L17.4208 6.31678L17.8331 6.63485L17.2752 7.06051L17.6945 7.38433L17.1393 7.88999L17.4801 8.13684L16.5755 9.19334L12.8651 8.11303L12.833 8.09579L10.1592 5.84027L17.0727 0.723145Z",
    fill: "#763E1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.927141 0.723145L7.84065 5.84027L5.16687 8.09579L5.13472 8.11303L1.4243 9.19334L0.519695 8.13683L0.860292 7.89017L0.305333 7.38433L0.723836 7.06086L0.157594 6.63399L0.585443 6.31572L0 3.50463L0.927141 0.723145Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6839 7.87671L16.6153 9.02131L17.8926 12.9578L14.523 12.9578L12.2012 12.9871L13.8897 9.6959L12.6839 7.87671Z",
    fill: "#F5841F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31629 7.87671L4.11034 9.6959L5.79907 12.9871L3.47842 12.9578H0.114746L1.38483 9.02134L5.31629 7.87671Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4881 2.89307L10.3885 5.86298L10.1552 9.87507L10.0659 11.1326L10.0588 14.345H7.94157L7.93471 11.1386L7.84512 9.87396L7.61166 5.86298L6.51221 2.89307H11.4881Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.f64160c67f3078ea946bd45f2b67373a.svg";
export { ForwardRef as ReactComponent };